var React = require("react");
var Radium = require("radium");

var style = {
	base: {
		height: '1em',
		transform: 'scale(1)',
		width: '1em',
		color: '#03a6dc',
		backgroundColor: 'currentColor',
		borderRadius: 1000,
		display: 'inline-block',
		margin: '0.12em',
		transition: 'all 0.13s ease-in-out'
	},

	checked: {
		backgroundColor: '#FFF',
		WebkitTransform: 'translate(0.9em, 0)',
		MozTransform: 'translate(0.9em, 0)',
		OTransform: 'translate(0.9em, 0)',
		transform: 'translate(0.9em, 0)'
	}
};

module.exports = Radium(
	React.createClass({
		render: function() {
			var me = this, props = me.props;

			return (
				<span style={[
					style.base,
					props.checked ? [style.base, style.checked] : style.base
				]}></span>
			);
		}
	})
);


// WEBPACK FOOTER //
// ./src/components/Toggle/Sign.jsx